import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useImportProductValidation = ({ storeId, setToastInfo }) => {
  const [showImportProductValidationDrawer, setShowImportProductValidationDrawer] = useState(false)
  const [validationFile, setValidationFile] = useState(null)
  const [validationError, setValidationError] = useState('')
  const [showImportInProgressModal, setShowImportInProgressModal] = useState(false)
  const { fetchData: importData, loading: importing } = useFetch(returnsServices.importProductValidation, {
    doInitialRequest: false,
  })

  const openImportProductValidationDrawer = () => {
    setShowImportProductValidationDrawer(true)
  }

  const closeImportProductValidationDrawer = () => {
    setShowImportProductValidationDrawer(false)
    setValidationError('')
    setValidationFile(null)
  }

  const onSelectValidationFile = files => {
    setValidationFile(files?.[0] || null)
  }

  const onDeleteValidationFile = fileName => {
    if (validationFile?.name === fileName) {
      setValidationFile(null)
    }
  }

  const onCloseImportInProgressModal = () => {
    setShowImportInProgressModal(false)
  }

  const onImportValidationFile = async () => {
    try {
      const formData = new FormData()
      formData.append('file', validationFile)
      await importData({ storeId, formData })
      closeImportProductValidationDrawer()
      setShowImportInProgressModal(true)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    openImportProductValidationDrawer,
    closeImportProductValidationDrawer,
    showImportProductValidationDrawer,
    onSelectValidationFile,
    onDeleteValidationFile,
    validationFile,
    setValidationFile,
    validationError,
    setValidationError,
    onImportValidationFile,
    importing,
    showImportInProgressModal,
    onCloseImportInProgressModal,
  }
}

export default useImportProductValidation
